export default {
  primary: '#6EBAC5',
  primary_variant: '#095D68',
  primary_label: '#323232',
  primary_variant_label: '#FFFFFF',
  primary_light: '#ACDDE4',
  primaryDropdownSelected: '#147582',

  secondary: '#323232',
  secondary_variant: '#FFFFFF',
  secondary_label: '#323232',
  secondary_dark: '#323232cc',

  tertiary: '#9E0A9A',
  tertiary_variant: '#80087C',
  tertiary_label: '#FFFFFF',

  background: '#F2F2F2',
  background_label: '#323232',

  surface: '#FFFFFF',
  surface_label: '#323232',

  overlay: 'rgba(51, 51, 51, 0.75)',

  form_field: '#FFFFFF',
  form_field_label: '#323232',
  form_field_border: '#6F6F6F',
  form_field_border_hover: '#147582',
  form_field_border_focus: '#6EBAC5',
  form_field_hint: '#6F6F6F',
  form_field_error_message: '#E12160',
  text_field_disabled_background: '#F5F5F5',

  disabled_background: '#F8F8F8',
  disabled_border: '#E5E5E5',
  disabled_text: '#B2B2B2',

  prefix: '#b5b5b5',

  error: '#E12160',
  error_label: '#FFFFFF',

  hyperlink: '#147582',
  hyperlink_hover_state: '#9E0A9A',

  black: '#212529',
  white: '#FFFFFF',

  close_hover: '#F0F0F0',

  time_hover: '#d9f0f4',

  searchResultText: '#6f6f6f',
  searchResultBackground: '#F2F2F2',
  searchResultBorder: '#e5e5e5',

  modalHeaderLine: '#b2b2b2',

  progressBarBackground: '#6eb9c5',
  progressBarFill: '#7dd1d8',

  slideToggleBackground: '#f7f7f7',
  navBackground: '#323232',

  dropdownArrow: '#9e0a9a',
  inputBorder: '#646464',

  switchSelected: '#366676',
  tableBorder: '#e5e5e5',

  text: '#323232',
};
